<template>
  <div>
    <apply-doc-component ref="applyDocTable" />
    <exam-check-list-component ref="examCheckTable" />
    <form-check-component @refetchTables="refetchTables" />
  </div>
</template>

<script>
import ApplyDocComponent from './components/ApplyDocComponent.vue'
import ExamCheckListComponent from './components/ExamCheckListComponent.vue'
import FormCheckComponent from '@/views/pages/additional-exam/components/FormCheckComponent.vue'

export default {
  name: 'View',
  components: {
    ApplyDocComponent,
    ExamCheckListComponent,
    FormCheckComponent,
  },
  methods: {
    refetchTables() {
      this.$refs.applyDocTable.refetchData()
      this.$refs.examCheckTable.refetchData()
    },
  },
}
</script>

<style scoped>

</style>
